import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import MainLayout from '../../components/layouts/MainLayout';
import PublicLayout from '../../components/layouts/PublicLayout';
import ProductGrid from '../../components/products/ProductGrid';
import Pagination from '../../components/common/Pagination';
import Button from '../../components/common/Button';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useProducts } from '../../hooks/useProducts';
import { categoryService } from '../../services/category.service';
import { theme } from '../../config/theme';
import { ArrowLeftIcon } from '../../components/icons/Icons';

const CategoryProducts = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [category, setCategory] = useState(null);
  const [categoryLoading, setCategoryLoading] = useState(true);

  useEffect(() => {
    fetchCategory();
  }, [slug]);

  const fetchCategory = async () => {
    try {
      const response = await categoryService.getBySlug(slug);
      setCategory(response.data.category);
    } catch (error) {
      navigate('/products');
    } finally {
      setCategoryLoading(false);
    }
  };

  const { products, pagination, loading, goToPage } = useProducts(
    { category_id: category?.id },
    {},
  );

  if (categoryLoading) return <LoadingSpinner fullScreen />;

  const content = (
    <div style={{ padding: theme.spacing.xl }}>
      <Button
        variant="ghost"
        onClick={() => navigate('/products')}
        style={{ marginBottom: theme.spacing.lg }}
      >
        <ArrowLeftIcon size={18} />
        Back to All Products
      </Button>

      <div style={{ marginBottom: theme.spacing.xl }}>
        <h1 style={{
          fontSize: theme.typography.fontSize['3xl'],
          fontWeight: theme.typography.fontWeight.bold,
          marginBottom: theme.spacing.xs,
        }}>
          {category?.name}
        </h1>
        {category?.description && (
          <p style={{ color: theme.colors.text.secondary }}>
            {category.description}
          </p>
        )}
        <div style={{
          marginTop: theme.spacing.md,
          fontSize: theme.typography.fontSize.sm,
          color: theme.colors.text.secondary,
        }}>
          {pagination.total || 0} products found
        </div>
      </div>

      <ProductGrid products={products} loading={loading} />

      <Pagination
        currentPage={pagination.page}
        totalPages={pagination.totalPages}
        hasNextPage={pagination.hasNextPage}
        hasPreviousPage={pagination.hasPreviousPage}
        totalItems={pagination.total}
        itemsPerPage={pagination.limit}
        onPageChange={goToPage}
      />
    </div>
  );

  return isAuthenticated ? (
    <MainLayout>{content}</MainLayout>
  ) : (
    <PublicLayout>{content}</PublicLayout>
  );
};

export default CategoryProducts;